module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mask-layer mask"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n        选择保险公司\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "search-box"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "select-wrap"
  }, [_c('div', {
    staticClass: "group margin-right-15"
  }, [_c('span', {
    staticClass: "left"
  }, [_vm._v("保险公司名称")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.model.no),
      expression: "model.no",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入保险公司名称"
    },
    domProps: {
      "value": (_vm.model.no)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "no", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "group btn-box"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("重置")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "main_wrap"
  }, [_c('div', {
    staticClass: "table_wrap"
  }, [_c('div', {
    staticClass: "table_layout"
  }, [_c('div', {
    staticClass: "table_scroll "
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.insuranceCompanyList,
      "max-height": "534",
      "border": "",
      "cell-style": _vm.cellStyle,
      "header-cell-style": _vm.tableHeaderColor
    }
  }, [_c('el-table-column', {
    key: "1",
    attrs: {
      "label": "排序",
      "min-width": "60",
      "sortable": "",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                      " + _vm._s(scope.row.id) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    key: "2",
    attrs: {
      "label": "保险公司名称",
      "min-width": "100",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                     " + _vm._s(scope.row.insuranceCompanyName) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    key: "3",
    attrs: {
      "label": "操作",
      "min-width": "100",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "primary pointer mr15",
          on: {
            "click": function($event) {
              return _vm.choose(scope.row)
            }
          }
        }, [_vm._v("选择")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), (!_vm.dataList.length) ? _c('div', [_c('nt-no-data')], 1) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取消")])]), _vm._v(" "), _c('div', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("X")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49717abe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/staffManagement/components/insurance.vue
// module id = Ka8M
// module chunks = 4